import React, { useContext, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import _helpers from '@toasttab/shared/src/globals/_helpers'
import MobileStickyCta from '@toasttab/shared/src/components/organisms/Navigation/Contentful/MobileStickyCta'
import NavController from '@toasttab/shared/src/components/organisms/Navigation/Contentful/NavController'
import { OTLContext } from '@toasttab/shared/src/context/OTLContext'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { HeaderProps } from '@toasttab/shared/src/components/organisms/Header/Header.d'
import BannerContainer from './BannerContainer'

const Header = ({
  enabledMobileStickyCTA = false,
  localizedEntries,
  siteId,
  siteMetadata
}: HeaderProps) => {
  const [readingMax, setReadingMax] = useState(0)
  const [readingProgress, setReadingProgress] = useState(0)

  const otlParams = useContext(OTLContext)
  const pageContext = usePageContext()
  const { packageName } = pageContext
  const headerStyle = pageContext?.headerStyle || 'Default'

  const ref = useRef<any | null>(null)

  const OTLArticleUX: boolean = Boolean(otlParams.isArticle)

  useEffect(() => {
    if (OTLArticleUX) {
      const trackScrollPosition = () => {
        const winHeight: any = window.innerHeight,
          docHeight: any = document.documentElement.scrollHeight

        // Set the max scrollable area
        const max = docHeight - winHeight

        setReadingMax(max)
        setReadingProgress(window.pageYOffset)
      }

      document.addEventListener('scroll', function () {
        trackScrollPosition()
      })
    }
  }, [OTLArticleUX])

  const headerClasses = classNames('sticky z-[100]', {
    'top-0 w-full z-50 bg-white transition-all': headerStyle !== 'Logo Only',
    'shadow-[rgba(0,0,0,0.08)]': OTLArticleUX && readingProgress > 100,
    'shadow-[rgba(0,0,0,0)]': !OTLArticleUX || readingProgress <= 100,
    'shadow-nav duration-300': OTLArticleUX,
    'duration-1000': !OTLArticleUX
  })

  return (
    <header className={headerClasses} ref={ref}>
      <div className='headerContent'>
        {['main', 'onTheLine'].includes(packageName) ? (
          <BannerContainer />
        ) : null}
        <NavController
          localizedEntries={localizedEntries}
          packageName={packageName}
          siteId={siteId}
          siteMetadata={siteMetadata}
        />
      </div>
      {siteId === 1 &&
      !['support'].includes(packageName) &&
      enabledMobileStickyCTA ? (
        <MobileStickyCta />
      ) : null}
      {OTLArticleUX ? (
        <progress
          className='absolute align-top'
          max={readingMax}
          value={readingProgress}
        />
      ) : null}
    </header>
  )
}

export default Header
